import apiClient from './client';

// ─── Typen ──────────────────────────────────────────────────────────────────

export interface FamilyMember {
  id: string;
  childId: string;
  relationshipId: string | null;
  parent1Id: string | null;
  parent2Id: string | null;
  relationType: 'biological' | 'adopted' | 'foster' | 'step';
  notes: string | null;
  child: { id: string; firstName: string; lastName: string | null };
  parent1: { id: string; firstName: string; lastName: string | null } | null;
  parent2: { id: string; firstName: string; lastName: string | null } | null;
  relationship: { id: string; type: string } | null;
}

export interface CreateFamilyMemberDto {
  child_id: string;
  relationship_id?: string;
  parent1_id?: string;
  parent2_id?: string;
  relation_type?: 'biological' | 'adopted' | 'foster' | 'step';
  notes?: string;
}

// ─── API-Funktionen ─────────────────────────────────────────────────────────

/** Kind-Eltern-Zuordnung erstellen */
export async function createFamilyMember(dto: CreateFamilyMemberDto): Promise<FamilyMember> {
  const { data } = await apiClient.post<FamilyMember>('/family-members', dto);
  return data;
}

/** Kind-Eltern-Zuordnung löschen */
export async function deleteFamilyMember(id: string): Promise<void> {
  await apiClient.delete(`/family-members/${id}`);
}
